var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCart = function SvgCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    fillRule: "evenodd",
    d: "M1 2.25a.75.75 0 0 0 0 1.5h2.432a.25.25 0 0 1 .242.19l.844 3.439 2.218 9.038a1.75 1.75 0 0 0 1.7 1.333h11.098a1.75 1.75 0 0 0 1.687-1.285l2.327-8.432a1.25 1.25 0 0 0-1.205-1.583H5.835L5.13 3.583a1.75 1.75 0 0 0-1.7-1.333zm7.193 13.81-1.99-8.11h15.812l-2.24 8.117a.25.25 0 0 1-.24.183h-11.1a.25.25 0 0 1-.242-.19M8.5 22a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m10 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3",
    clipRule: "evenodd"
  })));
};
export default SvgCart;